import React from 'react';
import SignupForm from '../../components/auth/SignupForm.component';
import authBg from '../../assets/images/auth/BG.jpg';
import ChatHelp from '../../components/chat-help/ChatHelp.component';
import { useTranslation } from 'react-i18next';
import MetaComp from '../../components/meta-comp/MetaComp.component';
import LegalLinks from '../../components/auth/LegalLinks.component';
import { useSelector } from 'react-redux';

const SignupPage = () => {
    const { t } = useTranslation();
    const clientData = useSelector(state => state.clientData);

    return(
        <main className='cm-page-container cm-auth-page-container d-flex row mx-0'>
            <MetaComp title={t("signup_page_title")}/>
            <div className='col-sm-12 col-md-6  cm-auth-content-wrap cm-signup-content-wrap d-flex align-items-center'>
                <div className='cm-auth-content-inner col-12'>
                    <div className="cm-txt-wrap">
                        <h2 className='h2 text-blue-gray-700 cm-fs-24 cm-mmc-font'>{t("welcome_login")} 
                            <span className='d-block h1 text-primary fw-bold cm-fs-40'>{clientData?.clientName ? clientData?.clientName : t("candidate_side_app_name")}</span>
                        </h2>
                        <h4 className='h4 text-blue-800'>{t("create_a_new_account")}</h4>
                    </div>

                    <hr className='cm-auth-hr bg-blue-gray-300' />

                    <SignupForm t={t} />

                    <LegalLinks />
                </div>
            </div>
            <div className='col-sm-6 py-8 cm-auth-bg-container position-relative d-none d-lg-block d-md-block w-md-50' style={{ backgroundImage: `url('${authBg}')` }}>
                <ChatHelp />
            </div>
        </main>
    )

}

export default SignupPage;